import React from 'react';
import { ResourceTypes, ResourceOperations } from '../../../authentication/resources';
import { Restricted } from '../../../authentication';
import { AdminHeaderLink, AdminRouterLink } from '../components/admin-area-menu-links';
import { joinURL } from '../../../utilities';
import { adminAreaPathName, generalTabLabel, generalTabPathName } from '../admin-area-pathnames';
import { outgoingDocumentTypeListPathName, followUpRuleListPathName, taskConfigurationListPathName, guideLinkListPathName, standardPhraseListPathName } from './general-pathnames';
import { useTenantAddons } from '../../../components/tenant-addons';

export function GeneralMenu() {
  const { isTenantAddonEnabled } = useTenantAddons();

  return (
    <Restricted
      actions={[
        { resourceType: ResourceTypes.BusinessConfiguration, resourceOperation: ResourceOperations.Read },
        { resourceType: ResourceTypes.AuditLog, resourceOperation: ResourceOperations.Read },
        { resourceType: ResourceTypes.GuideLinks, resourceOperation: ResourceOperations.Read },
      ]}
    >
      <AdminHeaderLink to={joinURL('/', adminAreaPathName, generalTabPathName)}>{generalTabLabel}</AdminHeaderLink>

      <Restricted denied=" " actions={[{ resourceType: ResourceTypes.BusinessConfiguration, resourceOperation: ResourceOperations.Read }]}>
        <AdminRouterLink to={joinURL('/', adminAreaPathName, generalTabPathName, outgoingDocumentTypeListPathName)}>Forsendelsestyper</AdminRouterLink>
      </Restricted>

      <Restricted denied=" " actions={[{ resourceType: ResourceTypes.BusinessConfiguration, resourceOperation: ResourceOperations.Read }]}>
        <AdminRouterLink to={joinURL('/', adminAreaPathName, generalTabPathName, followUpRuleListPathName)}>Opfølgningsregler</AdminRouterLink>
      </Restricted>
      <Restricted denied=" " actions={[{ resourceType: ResourceTypes.BusinessConfiguration, resourceOperation: ResourceOperations.Read }]}>
        <AdminRouterLink to={joinURL('/', adminAreaPathName, generalTabPathName, taskConfigurationListPathName)}>Opgavekonfiguration</AdminRouterLink>
      </Restricted>
      {isTenantAddonEnabled(['guideLinks']) && (
        <Restricted denied=" " actions={[{ resourceType: ResourceTypes.GuideLinks, resourceOperation: ResourceOperations.Read }]}>
          <AdminRouterLink to={joinURL('/', adminAreaPathName, generalTabPathName, guideLinkListPathName)}>Link i guider</AdminRouterLink>
        </Restricted>
      )}

      <Restricted denied=" " actions={[{ resourceType: ResourceTypes.BusinessConfiguration, resourceOperation: ResourceOperations.Read }]}>
        <AdminRouterLink to={joinURL('/', adminAreaPathName, generalTabPathName, standardPhraseListPathName)}>Standardfraser</AdminRouterLink>
      </Restricted>
    </Restricted>
  );
}
